import { gql } from 'apollo-angular';

export const GET_TENANT_NAME = gql`
  query ($id: ID!) {
    tenant(id: $id) {
      id
      name
    }
  }
`;

export const GET_CREDIT_WALLET = gql`
  query ($tenantId: ID!) {
    creditWallet(tenantId: $tenantId) {
      id
      tenantId
      plan
      initialPlanCredits
      planCredits
      planCreditsExpireAt
      purchasedCredits
      overConsumptionCredits
    }
  }
`;

export const GET_CREDIT_PURCHASES = gql`
  query ($criteria: SearchCreditPurchasesCriteria!) {
    creditPurchases(criteria: $criteria) {
      id
      tenantId
      credits
      reference
      purchasedAt
    }
  }
`;

export const GET_MONTH_CREDIT_CONSUMPTIONS = gql`
  query ($criteria: MonthCreditConsumptionsCriteria!) {
    monthCreditConsumptions(criteria: $criteria) {
      month
      year
      type
      count
      credits
      units
      totalCredits
    }
  }
`;

export const GET_CREDIT_WALLET_PLANS = gql`
  query {
    creditWalletPlans {
      name
      credits
    }
  }
`;
